import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import PromoCard from "@/components/PromoCard";
import { AlertTriangle } from "lucide-react";

const FILTERS = [
  { key: "all", label: "Tutte" },
  { key: "sport", label: "Sport" },
  { key: "casino", label: "Casinò" },
  { key: "virtual", label: "Virtual" },
  { key: "slot", label: "Slot e Games" },
];

export default function Promozioni() {
  const [promos, setPromos] = useState([]);
  const [bookmakers, setBookmakers] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/bookmakers").then((r) => setBookmakers(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const q = filter === "all" ? "" : `?category=${filter}`;
    api.get(`/promotions${q}`).then((r) => setPromos(r.data)).catch(() => {});
  }, [filter]);

  const bmName = useMemo(() => {
    const m = {};
    bookmakers.forEach((b) => (m[b.slug] = b.name));
    return m;
  }, [bookmakers]);

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14 sm:py-20">
      <span className="text-xs font-bold uppercase tracking-[0.25em] text-yellow-500">
        Bonus &amp; Bookmaker
      </span>
      <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter">
        Promozioni <span className="text-yellow-400">disponibili</span>
      </h1>
      <p className="mt-4 max-w-2xl text-zinc-400 leading-relaxed">
        Consulta le promozioni dei bookmaker partner e registrati attraverso i
        link ufficiali Vinko.
      </p>

      <div className="mt-6 rounded-xl border border-yellow-400/25 bg-yellow-400/5 p-4 flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-yellow-400 shrink-0 mt-0.5" />
        <p className="text-sm text-yellow-100/90">
          Le promozioni possono essere modificate o terminate dal bookmaker.
          Prima della registrazione consulta sempre i termini e le condizioni
          ufficiali.
        </p>
      </div>

      <div className="mt-8 flex gap-2 overflow-x-auto no-scrollbar pb-2">
        {FILTERS.map((f) => (
          <button
            key={f.key}
            onClick={() => setFilter(f.key)}
            data-testid={`promo-filter-${f.key}`}
            className={`shrink-0 rounded-full px-4 py-2 text-sm font-semibold border transition-colors duration-200 ${
              filter === f.key
                ? "bg-yellow-400 text-black border-yellow-400"
                : "border-white/15 text-zinc-300 hover:border-yellow-400/50 hover:text-yellow-400"
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {promos.map((p) => (
          <PromoCard key={p.id} promo={p} bookmakerName={bmName[p.bookmaker_slug]} />
        ))}
      </div>

      {promos.length === 0 && (
        <div className="mt-10 rounded-xl border border-white/10 bg-[#101010] p-8 text-center text-zinc-400">
          Nessuna promozione disponibile per questa categoria.
        </div>
      )}
    </div>
  );
}
